import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { observer } from "mobx-react";
import { __ } from "../../../utils";
import { Divider } from "antd";
const ImportFormResultMessage = observer((param)=>{
    let { result } = param;
    const generateFixLink = useCallback((param)=>{
        let { fix, settingsTab, cookieDuplicate, cookie, blockerDuplicate, blocker, href, linkText } = param;
        switch(fix){
            case "settings":
                return /*#__PURE__*/ _jsx("a", {
                    href: `#/settings/${settingsTab}`,
                    target: "_blank",
                    rel: "noreferrer",
                    children: __("Set manually")
                });
            case "cookieDuplicate":
                {
                    const { original: [originalGroupId, originalId], duplicate: [duplicateGroupId, duplicateId] } = cookieDuplicate;
                    return /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("a", {
                                href: `#/cookies/${originalGroupId}/edit/${originalId}`,
                                target: "_blank",
                                rel: "noreferrer",
                                children: __("Open original")
                            }),
                            " ",
                            "•",
                            " ",
                            /*#__PURE__*/ _jsx("a", {
                                href: `#/cookies/${duplicateGroupId}/edit/${duplicateId}`,
                                target: "_blank",
                                rel: "noreferrer",
                                children: __("Open newly created")
                            })
                        ]
                    });
                }
            case "cookie":
                {
                    const [group, id] = cookie;
                    return /*#__PURE__*/ _jsx("a", {
                        href: `#/cookies/${group}/edit/${id}`,
                        target: "_blank",
                        rel: "noreferrer",
                        children: __("Check manually")
                    });
                }
            case "blockerDuplicate":
                {
                    const { original, duplicate } = blockerDuplicate;
                    return /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("a", {
                                href: `#/blocker/edit/${original}`,
                                target: "_blank",
                                rel: "noreferrer",
                                children: __("Open original")
                            }),
                            " ",
                            "•",
                            " ",
                            /*#__PURE__*/ _jsx("a", {
                                href: `#/blocker/edit/${duplicate}`,
                                target: "_blank",
                                rel: "noreferrer",
                                children: __("Open newly created")
                            })
                        ]
                    });
                }
            case "blocker":
                {
                    return /*#__PURE__*/ _jsx("a", {
                        href: `#/blocker/edit/${blocker}`,
                        target: "_blank",
                        rel: "noreferrer",
                        children: __("Check manually")
                    });
                }
            case "link":
                {
                    return /*#__PURE__*/ _jsx("a", {
                        href: href,
                        rel: "noreferrer",
                        children: linkText || __("Set manually")
                    });
                }
            default:
                return null;
        }
    }, []);
    if (!result) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Divider, {
                style: {
                    marginTop: 0
                },
                children: __("Result")
            }),
            result.messages.map((param, i)=>{
                let { message, severity, ...fix } = param;
                return /*#__PURE__*/ _jsx("div", {
                    className: `notice notice-${severity} inline below-h2 notice-alt`,
                    style: {
                        margin: "10px 0 0 0"
                    },
                    children: /*#__PURE__*/ _jsxs("p", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                dangerouslySetInnerHTML: {
                                    __html: message
                                }
                            }),
                            !!fix.fix && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    " • ",
                                    generateFixLink(fix)
                                ]
                            })
                        ]
                    })
                }, i);
            })
        ]
    });
});
export { ImportFormResultMessage };
